export function fetcher(url: string) {
  return fetch(url, { credentials: 'include' }).then(async (res) => {
    if (res.status === 401 && typeof window !== 'undefined') {
      if (!window.location.pathname.startsWith('/login')) {
        const next = encodeURIComponent(
          window.location.pathname + window.location.search
        )
        window.location.href = `/login?next=${next}`
      }
      throw new Error('Unauthorized')
    }
    return res.json()
  })
}
